import React, {useEffect, useState} from 'react'
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import {
    getFaltaToEditAPI, updateFaltaAPI,
} from "../../../../consumers/backendApisUrls";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import Falta from "./Falta";
import {KEYS_FALTAS} from "./FaltasContantes";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {DetalleFaltaActions} from "./DetalleFaltaActions";

const DetalleFalta = ({toggleModal, row, fromAdminPage, manageSearch}) => {
    const SECTION_NAME = "DetalleFalta";
    const [executeManagePost] = useManagePostRequest();
    const [isEditable, setIsEditable] = useState(false);
    const [formValuesFalta, setFormValuesFalta] = useState({});

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();
    const [isUploading, setIsUploading] = useState(false);

    const init = async () => {
        const payload = {
            IdFalta: row?.IdFalta
        }
        await executeManagePost(getFaltaToEditAPI(), payload, succesGetFaltaToEditAPICallback);
    }

    const succesGetFaltaToEditAPICallback = ({data}) => {
        setFormValuesFalta({...data});
        setIsEditable(data?.PuedeEditar === true && fromAdminPage === true);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = getPayload();
        let keys = [];

        api = updateFaltaAPI();
        payload = {...formValuesFalta};
        keys = KEYS_FALTAS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitCallback);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const successSubmitCallback = async () => {
        toggleModal();
        manageSearch();
    }

    const getPayload = () => {
        return {
            ...formValuesFalta
        }
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <ModalForm titulo="Ver Detalle Falta"
                   width="1100px"
                   showModal={toggleModal}
                   hasSaveButton={false}
        >
            <div className="displayFlexWrap">

                <Falta
                    SECTION_NAME={SECTION_NAME}
                    idEmpleado={formValuesFalta?.IdEmpleado}
                    formValuesFaltas={formValuesFalta}
                    setFormValuesFaltas={setFormValuesFalta}
                    KEYS={KEYS_FALTAS}
                    fromAdminPage={fromAdminPage}
                    isCreate={false}
                    isEditable={isEditable}
                    IdFalta={row?.IdFalta}
                />

            </div>
            {isEditable &&
                <div className="d-flex justify-content-end mt-1 align-items-center">
                    <button
                        type="button"
                        className="mr-3 mb-1 btn btn-primary generic-button-ficha-modal generic-button-hover-azul"
                        disabled={isUploading || isSubmitting}
                        onClick={handleSubmit}
                    >
                        Actualizar  {isSubmitting && (<FontAwesomeIcon icon='spinner' transform="left-9" className="hand-pointer spinner ml-3"/>)}
                    </button>
                </div>
            }

            {(isEditable || fromAdminPage) && <DetalleFaltaActions
                refreshMainPage={manageSearch}
                toggleMainModal={toggleModal}
                formValues={formValuesFalta}
            />
            }

        </ModalForm>
    )
}

export default DetalleFalta;